import { EventHandler } from '@n7-frontend/core';

export class CompareSelectFilterEH extends EventHandler {
  public listen() {

    this.innerEvents$.subscribe(event => {
      switch(event.type){
        case 'compare-select-filter.click': 
          if(event.payload.isSelected) return;
          this.dataSource.onClick(event);
          this.emitOuter('click', event.payload);
          break;
        
        default:
          break;
      }
    });

    this.outerEvents$.subscribe(event => {
      if(event.type === 'chart-layout.chart-request'){
        this.dataSource.update(event.payload);  
      }
    });
  }
}